import React from "react";

const MRVPendingSummaryCard = ({
    data = {},
    onClick
}) => {

    // ==========================================
    // LIVE COUNTS FROM DASHBOARD API
    // ==========================================

    const poReceiving = Number(
        data?.totalPendingPOReceiving || 0
    );

    const localReceiving = Number(
        data?.totalPendingLocalReceiving || 0
    );

    const total =
        poReceiving +
        localReceiving;


    // ==========================================
    // SUMMARY ITEMS
    // ==========================================

    const summaryItems = [
        {
            key: "poReceiving",

            label: "PO Receipts",

            value: poReceiving,

            icon: "fa fa-shopping-cart",

            subLabel:
                "Pending PO Material Receipt",

            background:
                "linear-gradient(135deg, #2196f3 0%, #1565c0 100%)",

            iconBackground:
                "rgba(255,255,255,0.20)"
        },

        {
            key: "localReceiving",

            label: "Local Receipts",

            value: localReceiving,

            icon: "fa fa-map-marker",

            subLabel:
                "Pending Local Material Receipt",

            background:
                "linear-gradient(135deg, #ff9800 0%, #ef6c00 100%)",

            iconBackground:
                "rgba(255,255,255,0.20)"
        }
    ];


    // ==========================================
    // CLICK HANDLER
    // ==========================================

    const handleCardClick = () => {

        if (!onClick) return;

        onClick("mrv");
    };


    return (

        <div
            className="card border-0 mb-3"
            style={{
                borderRadius: "16px",

                overflow: "visible",

                // REMOVE FULL GREEN BACKGROUND
                background: "transparent",

                // SOFT SHADOW SAME AS REQUISITION
                boxShadow:
                    "0 6px 18px rgba(0,0,0,0.08)"
            }}
        >

            {/* ================= HEADER ================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    flex-wrap
                    gap-2
                "
                style={{
                    padding:
                        "10px 14px 3px 14px"
                }}
            >

                <div>

                    <div
                        className="
                            d-flex
                            align-items-center
                            gap-2
                        "
                    >

                        <h4
                            className="mb-0"
                            style={{
                                fontSize:
                                    "17px",

                                fontWeight:
                                    700,

                                color:
                                    "#212529"
                            }}
                        >
                            Material Receipt Processing
                        </h4>


                        <span
                            className="badge"
                            style={{
                                background:
                                    "#198754",

                                color:
                                    "#ffffff",

                                border:
                                    "1px solid #198754",

                                fontSize:
                                    "9px",

                                padding:
                                    "4px 8px"
                            }}
                        >
                            NEW
                        </span>

                    </div>


                    <div
                        className="mt-1"
                        style={{
                            color:
                                "#6c757d",

                            fontSize:
                                "10px"
                        }}
                    >
                        Overview of pending material receiving
                    </div>

                </div>


                {/* ================= VIEW DETAILS ================= */}

                <button
                    type="button"
                    className="btn btn-sm"
                    onClick={
                        handleCardClick
                    }
                    style={{
                        color:
                            "#343a40",

                        border:
                            "1px solid #ced4da",

                        borderRadius:
                            "8px",

                        padding:
                            "5px 11px",

                        fontSize:
                            "11px",

                        fontWeight:
                            600,

                        boxShadow:
                            "0 2px 6px rgba(0,0,0,0.06)"
                    }}
                >
                    View Details
                </button>

            </div>


            {/* ================= BODY ================= */}

            <div
                style={{
                    padding:
                        "7px 12px 18px"
                }}
            >

                <div className="row g-2">


                    {/* ================= TOTAL ================= */}

                    <div className="col-xl-4 col-lg-4 col-md-12">

                        <div
                            onClick={
                                handleCardClick
                            }
                            style={{
                                cursor:
                                    "pointer",

                                height:
                                    "100%",

                                minHeight:
                                    "88px",

                                borderRadius:
                                    "11px",

                                padding:
                                    "11px",

                                // KEEP TOTAL BOX GREEN
                                background:
                                    "linear-gradient(135deg, #43a77d 0%, #198754 100%)",

                                border:
                                    "1px solid rgba(255,255,255,0.30)",

                                boxShadow:
                                    "0 6px 14px rgba(0,70,45,0.20)"
                            }}
                        >

                            <div
                                className="
                                    d-flex
                                    align-items-center
                                    gap-2
                                "
                            >

                                {/* ICON */}

                                <div
                                    className="
                                        d-flex
                                        align-items-center
                                        justify-content-center
                                    "
                                    style={{
                                        width:
                                            "42px",

                                        height:
                                            "42px",

                                        borderRadius:
                                            "50%",

                                        background:
                                            "rgba(255,255,255,0.20)",

                                        flexShrink:
                                            0
                                    }}
                                >

                                    <i
                                        className="fa fa-truck"
                                        style={{
                                            fontSize:
                                                "18px",

                                            color:
                                                "#ffffff"
                                        }}
                                    />

                                </div>


                                {/* COUNT */}

                                <div>

                                    <div
                                        style={{
                                            fontSize:
                                                "25px",

                                            fontWeight:
                                                700,

                                            lineHeight:
                                                1,

                                            color:
                                                "#ffffff"
                                        }}
                                    >
                                        {total}
                                    </div>


                                    <div
                                        className="mt-1"
                                        style={{
                                            fontSize:
                                                "11px",

                                            fontWeight:
                                                600,

                                            color:
                                                "#ffffff"
                                        }}
                                    >
                                        Total Pending
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>


                    {/* ================= PO + LOCAL ================= */}

                    <div className="col-xl-8 col-lg-8 col-md-12">

                        <div className="row g-2">

                            {summaryItems.map(
                                (summary) => (

                                    <div
                                        key={
                                            summary.key
                                        }
                                        className="
                                            col-xl-6
                                            col-lg-6
                                            col-md-6
                                            col-sm-6
                                        "
                                    >

                                        <div
                                            onClick={
                                                handleCardClick
                                            }
                                            style={{
                                                cursor:
                                                    "pointer",

                                                height:
                                                    "100%",

                                                minHeight:
                                                    "88px",

                                                borderRadius:
                                                    "11px",

                                                padding:
                                                    "10px",

                                                background:
                                                    summary.background,

                                                border:
                                                    "1px solid rgba(255,255,255,0.28)",

                                                boxShadow:
                                                    "0 6px 14px rgba(0,0,0,0.16)"
                                            }}
                                        >

                                            <div
                                                className="
                                                    d-flex
                                                    align-items-center
                                                    gap-2
                                                "
                                            >

                                                {/* ICON */}

                                                <div
                                                    className="
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                    "
                                                    style={{
                                                        width:
                                                            "38px",

                                                        height:
                                                            "38px",

                                                        borderRadius:
                                                            "50%",

                                                        background:
                                                            summary.iconBackground,

                                                        flexShrink:
                                                            0
                                                    }}
                                                >

                                                    <i
                                                        className={
                                                            summary.icon
                                                        }
                                                        style={{
                                                            fontSize:
                                                                "16px",

                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    />

                                                </div>


                                                {/* COUNT + LABEL */}

                                                <div>

                                                    <div
                                                        style={{
                                                            fontSize:
                                                                "21px",

                                                            fontWeight:
                                                                700,

                                                            lineHeight:
                                                                1,

                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    >
                                                        {
                                                            summary.value
                                                        }
                                                    </div>


                                                    <div
                                                        className="mt-1"
                                                        style={{
                                                            fontSize:
                                                                "11px",

                                                            fontWeight:
                                                                600,

                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    >
                                                        {
                                                            summary.label
                                                        }
                                                    </div>

                                                </div>

                                            </div>


                                            {/* STATUS */}

                                            <div
                                                className="mt-2"
                                                style={{
                                                    fontSize:
                                                        "9px",

                                                    fontWeight:
                                                        500,

                                                    lineHeight:
                                                        "12px",

                                                    color:
                                                        "rgba(255,255,255,0.90)",

                                                    minHeight:
                                                        "12px"
                                                }}
                                            >
                                                {
                                                    summary.subLabel
                                                }
                                            </div>

                                        </div>

                                    </div>

                                )
                            )}

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};


export default MRVPendingSummaryCard;